// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/modules'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/home/index.vue'),
    meta: {title: 'Home'},
    props: () => ({
      type: 'INFP',
      sn: 'INFPbaef991de43c2f4a89d6eaf20754e210'
    })
  },
  {
    // 🔑 关键：匹配 /INFP.html 这样的路径
    path: '/:type.html',
    name: 'Home',
    component: () => import('@/views/home/index.vue'),
    meta: { title: 'Home' },
    // 支持通过 props 接收参数
    props: (route) => ({
      type: route.params.type,
      sn: route.query.sn  
    })
  },
  {
    path: '/guidance.html',
    name: 'Guidance',
    component: () => import('@/views/home/guidance.vue'),
    meta: { title: 'Guidance' }
  },
  {
    path: '/soul.html',
    name: 'Soul',
    component: () => import('@/views/home/soul.vue'),
    meta: { title: 'Soul Compatibility Test' }
  },
  {
    path: '/result.html',
    name: 'Result',
    component: () => import('@/views/home/result.vue'),
    meta: { title: 'Soul Compatibility Test' }
  },
  {
    path: '/atlas.html',
    name: 'Atlas',
    component: () => import('@/views/atlas/index.vue'),
    meta: { title: 'Atlas' }
  },
  {
    path: '/yearbook.html',
    name: 'Yearbook',
    component: () => import('@/views/atlas/yearbook.vue'),
    meta: { title: 'My Growth Yearbook' }
  },
  {
    path: '/mine.html',
    name: 'Mine',
    component: () => import('@/views/mine/index.vue'),
    meta: { title: 'Mine' }
  },
  {
    path: '/member.html',
    name: 'Member',
    component: () => import('@/views/mine/member.vue'),
    meta: { title: 'Member' }
  }
  // {
  //   path: '/detail/:id.html',
  //   name: 'Detail',
  //   component: () => import('@/views/Detail/index.vue'),
  //   meta: { 
  //     title: '详情',
  //     requiresAuth: false
  //   },
  //   props: (route) => ({
  //     id: route.params.id,
  //     sn: route.query.sn
  //   })
  // },
  // {
  //   path: '/404.html',
  //   name: 'NotFound',
  //   component: () => import('@/views/NotFound/index.vue'),
  //   meta: { title: '404' }
  // },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: '/404.html'
  // }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '个人神谕卡'
  
  if (to.meta.requiresAuth) {
    const isLogin = store.state.user.isLogin
    if (!isLogin) {
      window.dispatchEvent(new CustomEvent('show-login'))
      next(false)
      return
    }
  }
  
  if (to.path === '/register.html' && store.state.user.isLogin) {
    next('/')
    return
  }
  
  next()
})

export default router